import { getFormattingLocales } from './getFormattingLocales';

// Binary (IEC) units: 1024 bytes = 1 KiB, 1024² = 1 MiB, 1024³ = 1 GiB
const FILE_SIZE_STEPS = [
  { threshold: 1024 ** 3, suffix: ' GB' },
  { threshold: 1024 ** 2, suffix: ' MB' },
  { threshold: 1024, suffix: ' KB' },
  { threshold: 0, suffix: ' B' },
];

// File size is formatted with binary (IEC) unit suffixes
export const fileSizeFormatter = (
  bytes: number,
  options?: Intl.NumberFormatOptions,
  locales?: string | string[]
) => {
  const resolvedLocales = locales ?? getFormattingLocales();

  const formatterOptions = {
    useGrouping: true,
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    ...options,
  };

  const sizeStep = FILE_SIZE_STEPS.find((step) => step.threshold <= bytes);

  if (sizeStep) {
    const fileSize = new Intl.NumberFormat(resolvedLocales, {
      ...formatterOptions,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(bytes / Math.max(1, sizeStep.threshold));

    return `${fileSize}${sizeStep.suffix}`;
  }

  return new Intl.NumberFormat(resolvedLocales, formatterOptions).format(bytes);
};
